module.exports = __webpack_public_path__ + "img/American_Amicable_logo_recreated_BLACK_19-07-09.f1a2e5cb.png";